import { RootState } from '../store';

export const selectCanModifyRTQ = (state: RootState): boolean => [1, 3, 7, 10, 11].includes(state.auth.user?.roleID ?? -1);

export const selectCanViewAccountMandateReport = (state: RootState): boolean => [1, 7, 8, 9, 11].includes(state.auth.user?.roleID ?? -1);
export const selectCanViewAmlReports = (state: RootState): boolean => [1, 7, 11].includes(state.auth.user?.roleID ?? -1);

export const selectCanViewOwnFlowsOnly = (state: RootState): boolean => [2, 3, 4, 5, 10].includes(state.auth.user?.roleID ?? -1);
